import { browserWindow } from 'utils/window';
// The environments for this project are a little different than other projects
// This logic bases the environment setting on the url domain.
//
// So www.hometap.com == "production"
// Netlify paths like veranda-prod.netlify.app or deploy previews == "stage"
// Local development == "development"

export const getEnv = () => {
  if (process.env.NODE_ENV === 'production') {
    const origin = browserWindow.location.origin;
    if (origin.includes('hometap.com')) {
      return 'production';
    } else {
      return 'stage';
    }
  } else {
    return 'dev';
  }
};

// Pass an object into this method with this object:
// { production: VARIABLE, stage: VARIABLE, dev: VARIABLE }
// and it will return the correct one for the environment
export const getVariableForEnv = (obj) => {
  const env = getEnv();
  return obj[env];
};
